import { BuilderConfig } from '../../types/Builder';

import BusinessHubIndustriesOptionalQuote, { IndustriesOptionalQuoteProps } from './business-hub-industries-optional-quote';

export const BusinessHubIndustriesOptionalQuoteBuilderConfig = {
    name: 'Business Hub Industries Optional Quote',
    inputs: [
        {
            name: 'quote',
            type: 'richText',
        },
        {
            name: 'author',
            type: 'richText',
        },
        {
            name: 'illustration',
            type: 'file',
            required: true,
        },
        {
            name: 'background',
            type: 'color',
        },
        {
            name: 'textColor',
            type: 'color',
        },
        {
            name: 'textSize',
            type: 'enum',
            enum: ['default', 'small'],
        },
        {
            name: 'reversed',
            type: 'boolean',
        },
        {
            name: 'hideIllustrationOnMobile',
            type: 'boolean',
        },
        {
            name: 'gridTemplateColumns',
            type: 'text',
            helperText: 'https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-columns',
        },
    ],
};

const builderConfig: BuilderConfig<IndustriesOptionalQuoteProps> = {
    component: BusinessHubIndustriesOptionalQuote,
    config: BusinessHubIndustriesOptionalQuoteBuilderConfig,
};

export default builderConfig;
